(function() {
    'use strict';
    angular
        .module('ordiniApp')
        .factory('Struttura', Struttura);

    Struttura.$inject = ['$resource', 'DateUtils'];

    function Struttura ($resource, DateUtils) {
        var resourceUrl =  'api/strutturas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dataCreazione = DateUtils.convertDateTimeFromServer(data.dataCreazione);
                        data.dataAggiornamento = DateUtils.convertDateTimeFromServer(data.dataAggiornamento);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
